import { cn } from "../..";
import { Wrap } from "./Wrap";

interface SkeletonProps {
	noOfLines?: number;
	className?: string;
	wrapperClassName?: string;
	dark?: boolean;
	align?: "left" | "center" | "right";
}

export function Skeleton(props: SkeletonProps) {
	const { noOfLines = 1, className, wrapperClassName, align = "left", ...remainingProps } = props;

	function Component({ className, dark }: Pick<SkeletonProps, "className" | "dark">) {
		return (
			<div
				className={cn(className, "animate-pulse rounded", {
					"bg-shades-light": !dark,
					"bg-shades": dark,
				})}
			/>
		);
	}

	return (
		<Wrap
			if={noOfLines > 1}
			with={(children) => <div className={cn("space-y-2", wrapperClassName)}>{children}</div>}
		>
			{Array.from({ length: noOfLines }).map((_v, i) => {
				const isLastAndNotOnly = i + 1 === noOfLines && noOfLines !== 1;

				return (
					<Component
						className={cn(className, {
							"h-4": !className,
							"w-3/4": isLastAndNotOnly,
							"mr-auto": isLastAndNotOnly && (align === "left" || align === "center"),
							"ml-auto": isLastAndNotOnly && (align === "right" || align === "center"),
						})}
						{...remainingProps}
						key={i}
					/>
				);
			})}
		</Wrap>
	);
}
